// eslint-disable-next-line
export const delay = ms => new Promise(res => setTimeout(res, ms))



// WEBPACK FOOTER //
// ./services/sagas.js